export default __webpack_public_path__ + "static/media/7.1045b164.jpeg";